module.exports = __webpack_public_path__ + "static/media/termo_autorizacao_instalacao_go.f61615ad.pdf";